//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "PopupCard",
  props: ["popupItems", "label"],
  components: {},
  mounted: () => { },
  data: () => ({

  }),
  methods: {}
};
